import {strip} from '@/common/questionsExporter/utility'

const groupingQuestion = (question) => {
    const strippedPrompt = strip(question.question)

    const regions = question.regions ? question.regions : []
    const formattedRegions = regions.map((region) => region.title).join("\n")

    const items = question.items ? question.items : []
    const itemMapper = (item) => {
        const value = strip(item.value, false)
        const region = item.region ? item.region : ''

        return `${value} (region: ${region})`
    }
    const formattedItems = items.map(itemMapper).join("\n")

    return `${strippedPrompt}\nRegions:\n${formattedRegions}\nItems:\n${formattedItems}`
}

export {groupingQuestion}
